import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  continue: {
    defaultMessage: 'Continue',
    id: 'AddCredentialsPage.continue',
  },
  agree: {
    defaultMessage: 'I agree',
    id: 'AddCredentialsPage.agree',
  },
  logInToYourBank: {
    defaultMessage: 'Log in to your bank',
    id: 'AddCredentialsPage.logInToYourBank',
  },
  logInToYourBankParametrized: {
    defaultMessage: `Log in to {providerName}`,
    id: 'AddCredentialsPage.logInToYourBankParametrized',
  },
  bankCode: {
    defaultMessage: 'Bank code: {bankCode}',
    id: 'Handoff.bankCode',
  },
  loginCredentialsTip: {
    defaultMessage: 'Use the same login details as you would use in the bank’s app or site.',
    id: 'LoginTemplate.loginCredentialsTip',
  },
  loginCredentialsDataAccessProvider: {
    defaultMessage:
      'By providing your credentials to Tink, you will allow Tink to access your personal data. Tink partners with {dataAccessProvider} to provide this service.',
    id: 'LoginTemplate.loginCredentialsDataAccessProvider',
  },
});
